import { Fragment, useCallback, useState } from 'react';
import { Box, Drawer, IconButton, Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import { fetchAPI } from '../../../api/request';
import Loading from '../../common/Loading.component';
import Alert from '../../common/Alert.component';
import _ from 'lodash';
import CloseIcon from '@mui/icons-material/Close';
import EditView from '../../../views/Edit.view';

const UpdateItem = ({
  setSuccessEdit = () => {},
  module: { edit },
  disabled = false,
  data,
  children,
  open,
  handleClose,
  remainingFiles,
}) => {
  const { jwt } = useSelector((state) => state.login);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const onError = useCallback((err) => {
    setSuccess(false);
    setLoading(false);
    setError(err?.response?.data?.error?.message || 'An error has occurred');
    // eslint-disable-next-line
  }, []);

  const onSuccess = useCallback(() => {
    setLoading(false);
    setSuccess(true);
    setTimeout(() => {
      localStorage.setItem('idLogbook', data?.id_logbook);
      setSuccessEdit((prev) => !prev);
    }, 1000);
    // eslint-disable-next-line
  }, [data, setSuccessEdit]);

  const onSubmit = useCallback(
    async (values) => {
      setLoading(true);
      setError(null);

      const keyattachment = `attachment_${values?.id}`;
      let data = {
        available: values.available?.id,
        quantity: !_.isEmpty(values.quantity) ? values.quantity : null,
        quantity_type: values.quantity_type?.id,
        note: values?.note,
        internal_note: values?.internal_note,
        id_item: values?.id_item?.id,
        attachment: remainingFiles || null,
      };
      let obj = { data: data };

      if (values?.[keyattachment]) {
        const formData = new FormData();

        Array.from(values?.[keyattachment])?.map((file) =>
          formData.append('files.attachment', file, file?.name)
        );
        formData.append('data', JSON.stringify(data));
        obj = formData;
      }

      fetchAPI(
        { path: `/list-items/${values?.id}`, method: 'PUT' },
        {},
        '',
        obj,
        jwt
      )
        .then(() => {
          onSuccess();
        })
        .catch(onError);
    },
    [setLoading, jwt, onError, onSuccess, remainingFiles]
  );

  return (
    <Stack>
      {loading && <Loading />}
      {success && <Alert severity='success'>{'Success'}</Alert>}

      {error && <Alert severity='error'>{error}</Alert>}

      <Fragment>
        <Drawer open={open || false} onClose={handleClose} anchor={'right'}>
          <Box sx={style}>
            <IconButton
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
              disabled={disabled}
            >
              <CloseIcon />
            </IconButton>
            <EditView
              data={data}
              conf={edit.conf}
              onEditSubmit={onSubmit}
              disabled={loading}
            >
              {children}
            </EditView>
          </Box>
        </Drawer>
      </Fragment>
    </Stack>
  );
};

const style = {
  bgcolor: 'background.paper',
  p: 4,
  pt: 10,
};
export default UpdateItem;
